import React from "react";
import { withRouter } from "react-router-dom";
import PayForRequest from "./PayForRequest";

function Pay(props) {
  const { requestData } = props;
  const { id } = requestData.request;
  return (
    <>
      <div className="row pt-4 pb-3">
        <div className="col-12">
          <button
            className="custom-buton custom-buton-large w-100"
            // data-toggle="modal"
            // data-target="#pay-for-request"
            onClick={() =>
              props.history.push("/dashboard/my-requests/make-payment/" + id)
            }
          >
            Pay
          </button>
        </div>
      </div>
      {/* <div
        className="modal fade pb-m-80 mt-m-80"
        id="pay-for-request"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="change-filter-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-show-all"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <PayForRequest requestData={requestData} />
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default withRouter(Pay);
